import React from "react";
import { CV } from "../components/cv";
import AntonImg from "@/assets/images/anton.png";

export default function CVAntonAlfsson() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Anton Alfsson";
  }, []);

  return (
    <CV
      name="Anton Alfsson"
      photo={AntonImg}
      title="Software Developer"
      subtitle="Systems developer with deep Java/Spring and API expertise, working across integrations, microservices and complex data environments in both private and public sector."
      summary="Experienced systems developer with an extensive technical background across a variety of programming languages and tools, with particular expertise in Java, Spring and API services. Uses AI-assisted development tools such as GitHub Copilot, ChatGPT, OpenAI Codex and Claude Code for code generation, debugging, refactoring and rapid prototyping. Used to working in teams and driving projects forward, with a deep understanding of integration solutions and managing complex data environments."
      skills={{
        Programming: [
          "Java",
          "Spring Boot",
          "Python",
          "TypeScript",
          "Node.js",
          "React",
        ],
        "Architecture & Integration": [
          "Microservices",
          "REST",
          "SOAP",
          "OAuth2 / OIDC",
          "RabbitMQ",
          "ActiveMQ",
          "Mulesoft",
        ],
        "Cloud & Platforms": [
          "AWS (Lambda, API Gateway, DynamoDB, IAM, S3, CloudWatch)",
          "OpenShift",
          "Docker",
        ],
        "Tools & Data": [
          "Git",
          "Jenkins",
          "Maven",
          "Gradle",
          "SonarQube",
          "Kibana",
          "Elasticsearch",
          "Splunk",
          "PostgreSQL",
          "MySQL",
          "MongoDB",
          "DynamoDB",
        ],
        "AI-assisted development": [
          "GitHub Copilot",
          "ChatGPT",
          "OpenAI Codex",
          "Claude Code",
        ],
        Languages: ["Swedish (native)", "English (full professional)"],
      }}
      experience={[
        {
          role: "Software Developer",
          company: "Axis Communications",
          period: "2024 – Present",
          description:
            "Part of the team responsible for authentication and authorization for all users with a MyAxis account. The platform secures access to Axis digital services and is used by customers and partners worldwide.",
          highlights: [
            "Identity management, access control and secure login flows.",
            "Integration with internal and external systems, with a strong focus on scalability, reliability and security.",
            "Tech: React, TypeScript, Node.js, Java, Spring Boot, Maven, Python, AWS (Lambda, API Gateway, DynamoDB, IAM, S3, CloudWatch), OAuth2 / OpenID Connect, REST, microservices, Docker, Git, AI-assisted development.",
          ],
        },
        {
          role: "Software Developer",
          company: "Resurs Bank",
          period: "2022 – 2024",
          description:
            "Developed the Merchant Portal, used by companies across the Nordic region to manage transactions, bonus checks, user roles and statistics.",
          highlights: [
            "Tech: TypeScript, React, Node.js, Java, Spring Boot, PostgreSQL, MongoDB, RabbitMQ, Docker, REST, OpenShift, Jenkins, Kibana, Elasticsearch, microservices, SonarQube, Gradle, Maven.",
          ],
        },
        {
          role: "Software Developer",
          company: "The Swedish Tax Agency",
          period: "2019 – 2022",
          description:
            "Worked in an agile team integrating a variety of systems supporting the application process for SINK applications.",
          highlights: [
            "Tech: Java, Spring Boot, Gradle, REST, SOAP, OpenShift, MySQL, Mulesoft, ActiveMQ, Jenkins, Kibana, Splunk, Git.",
          ],
        },
        {
          role: "Software Developer",
          company: "ADB Safegate",
          period: "2018 – 2019",
          description:
            "Project-based solution translating and connecting airports' internal systems with Safegate's product for gate solutions.",
          highlights: ["Tech: Java, REST, JMS, Wildfly, XML/XSLT."],
        },
      ]}
      education={[
        {
          degree: "Software Developer Java",
          institution: "Newton, Malmö",
          year: "2016 – 2018",
        },
      ]}
    />
  );
}
